import { jsx } from "react/jsx-runtime";
import classnames from "../../utils/classnames.js";
import HeaderBackButton from "./HeaderBackButton.js";
import HeaderCarInfo from "./HeaderCarInfo.js";
import HeaderCounter from "./HeaderCounter.js";
import HeaderCounterButton from "./HeaderCounterButton.js";
import HeaderHeading from "./HeaderHeading.js";
import HeaderLink from "./HeaderLink.js";
import HeaderMarkers from "./HeaderMarkers.js";
import HeaderParametersToggler from "./HeaderParametersToggler.js";
import HeaderSort from "./HeaderSort.js";
import HeaderStatus from "./HeaderStatus.js";
import './Header.css';/* empty css            */
const Header = ({ className, children, border = true, ...props }) => {
  return /* @__PURE__ */ jsx(
    "header",
    {
      className: classnames(
        [
          "perxis-auto-header",
          {
            "perxis-auto-header--without-border": !border
          }
        ],
        className
      ),
      ...props,
      children
    }
  );
};
Header.ParametersToggler = HeaderParametersToggler;
Header.Counter = HeaderCounter;
Header.Sort = HeaderSort;
Header.BackButton = HeaderBackButton;
Header.CarInfo = HeaderCarInfo;
Header.Markers = HeaderMarkers;
Header.Status = HeaderStatus;
Header.CounterButton = HeaderCounterButton;
Header.Heading = HeaderHeading;
Header.Link = HeaderLink;
export {
  Header as default
};
//# sourceMappingURL=Header.js.map
